import React from "react";

function IconNetworkError() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="31" version="1">
      <g fill="#000" transform="matrix(.11786 0 0 .11787 -1.464 -24.782)">
        <path
          fillOpacity="1"
          fillRule="evenodd"
          stroke="none"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="bevel"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.559"
          d="M290 457.362c0 13.807-8.954 25-20 25s-20-11.193-20-25 8.954-25 20-25 20 11.193 20 25z"
          opacity="1"
          transform="matrix(2.375 0 0 1.9 -391.25 -445.376)"
        ></path>
        <path d="M15 467.362c20-135 115-255 235-255s215 120 235 255c1 5-24 5-25 0-25-95-90-185-210-185s-185 90-210 185c-1 5-26 5-25 0z"></path>
      </g>
    </svg>
  );
}

export default IconNetworkError;